
import Vue from "vue";
import { ILockscreenNfcBadge, LockScreenService } from "@/services/lockscreen-service";
import AppNfcPinCodeInput from "./NfcPinCodeInput.vue";

export default Vue.extend({
	data(){
		return {
			label: "",
			pinCode: null as null | string,
			pinCodeBlured: false,
			clearPinCode: false,
			isSaving: false,
		};
	},
	props: {
		value: {
			type: Object as ()=>ILockscreenNfcBadge,
			required: true
		},
		existingBadges: {
			type: Array as ()=>ILockscreenNfcBadge[],
			required: true
		}
	},
	computed: {
		isLabelUnique():boolean {
			for (let badge of this.existingBadges) {
				if (badge.Label == this.label.trim() && badge.ID != this.value.ID) {
					return false;
				}
			}
			return true;
		},
		valid():boolean {
			if (!this.label) return false;
			if (!this.isLabelUnique) return false;
			if (!this.pinCodeIsValid) return false;
			return true;
		},
		pinCodeIsValid():boolean{
			if (this.pinCode == null) return true;
			return LockScreenService.isPinCodeValid(this.pinCode);
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.label = this.value.Label;
			}
		}
	},
	methods: {
		setChangePincode(value:boolean){
			if (value){
				this.pinCode = "";
			}else{
				this.pinCode = null;
			}
		},
		close(){
			this.$emit("close");
		},
		async confirm(){
			if (!this.valid) return;
			if (this.isSaving) return;
			this.isSaving = true;
			try{
				await LockScreenService.editBadge(this.value.ID, this.label, this.pinCode);
				this.$emit("refresh");
				this.close();
			}catch(err){

			}
			this.isSaving = false;
		},
	},
	components: {
		AppNfcPinCodeInput
	},
	i18nEx: {
		componentPrefix: "components.LockScreen"
	}
});

